<!-- Intro Placeholders -->
@if (renderMode === 'chrome-extension' && !entity && !showSpinner) {
  <article id="{{ renderMode }}">
    <section id="intro-placeholder">
      <div class="box-files-container">
        <div class="box-no-files-text placeholder-text no-entity">
          <span>{{ navigateLabel }}</span>
        </div>
      </div>
    </section>
  </article>
}

@if (entity?.name) {
  <article
    (click)="openFileList()"
    id="{{ renderMode }}"
    class="files-section"
    [ngClass]="filesListOpen ? 'file-section-open' : 'file-section-closed'"
    [matTooltip]="'Edit and merge files for ' + entity.name + ' (Alt+Shift+F)'"
    [matTooltipDisabled]="filesListOpen"
    matTooltipShowDelay="500"
    matTooltipPosition="above"
    >
    <mat-icon
      fontIcon="expand_less"
      class="expand-section-icon"
      (click)="closeFileList(); $event.stopPropagation()"
      [matTooltip]="filesListOpen ? 'Close file list' : 'View file list'"
      matTooltipShowDelay="500"
      role="button"
      tabindex="0"
      (keydown.enter)="closeFileList(); $event.stopPropagation()"
      (keydown.space)="closeFileList(); $event.stopPropagation()"
    ></mat-icon>
    <!--// Button-->
    <section
      id="awesomedoc-section-button"
      (click)="closeFileList(); $event.stopPropagation()"
      (keydown.enter)="openFileList()"
      (keydown.space)="openFileList()"
      tabindex="0"
      >
      <h3 class="box-title-bar heading-underline">
        <span class="box-title-text">
          @if (renderMode !== 'chrome-extension') {
            <mat-icon fontSet="material-icons-outlined">description</mat-icon>
          }
          @if (renderMode === 'chrome-extension') {
            @if (findEntityMeta(entity.type)?.iconUrl; as iconUrl) {
              <app-salesforce-entity-icon
                [iconUrl]="iconUrl"
                [iconColor]="findEntityMeta(entity.type)?.iconColor"
                [iconClass]="getIcon(entity.type)"
                imgClass="entity-icon-img file-list-title-icon"
                [tooltip]="entityLabel | titlecase">
              </app-salesforce-entity-icon>
            } @else {
              <i
                class="{{ getIcon(entity.type) }} {{ entity.type }}"
                [matTooltip]="entityLabel | titlecase"
                matTooltipShowDelay="500"
              ></i>
            }
          }
          <span>
            <span class="small-title-text">Edit and merge files for </span>
            <span>
              @if (!filesListOpen && renderMode !== 'chrome-extension') {
                @if (findEntityMeta(entity.type)?.iconUrl; as iconUrl) {
                  <app-salesforce-entity-icon
                    [iconUrl]="iconUrl"
                    [iconColor]="findEntityMeta(entity.type)?.iconColor"
                    [iconClass]="getIcon(entity.type)"
                    imgClass="entity-icon-img file-list-title-icon"
                    [tooltip]="entityLabel | titlecase">
                  </app-salesforce-entity-icon>
                } @else {
                  <i
                    [matTooltip]="entityLabel | titlecase"
                    matTooltipShowDelay="500"
                    class="entity-icon {{ getIcon(entity.type) }}"
                    >
                  </i>
                }
              }
            </span>
            <span class="main-title-text">{{ entity.name }}</span>
          </span>
          <mat-icon class="big-watermark-icon" fontSet="material-icons-outlined">description</mat-icon>
          @if (filesListOpen && renderMode === 'web-app') {
            <span class="header-search-and-refresh">
              <span class="header-search-input-wrapper">
                <input #searchInputEl class="header-search-input" type="text" placeholder="Search (Ctrl+Shift+E)..."
                  (input)="onSearchInput($event)" (click)="$event.stopPropagation()" (keydown.escape)="clearSearch()" />
                <mat-icon class="header-search-icon" [fontIcon]="searchInputEl.value ? 'close' : 'search'"
                  (click)="clearSearch(); $event.stopPropagation()"></mat-icon>
              </span>
              <mat-icon
                fontIcon="autorenew"
                class="sync-icon"
                (click)="refreshFiles($event)"
                [matTooltip]="'Refresh'"
                matTooltipShowDelay="500"
                role="button"
                tabindex="0"
                (keydown.enter)="refreshFiles($event)"
              ></mat-icon>
            </span>
          }
        </span>
      </h3>
    </section>
    <!--// File list-->
    @if (filesListOpen) {
      <section id="awesomedoc-list">
        <div class="box-files-container">
          @if (showSpinner && renderMode !== 'web-app') {
            <app-skeleton [style]="'entity-h3-icon'"></app-skeleton>
          }
          @if (showSpinner && renderMode !== 'web-app') {
            <app-skeleton [style]="'heading-h3-text'"></app-skeleton>
          }
          @if (renderMode === 'chrome-extension' && entity?.name) {
            <h3 class="box-title-bar heading-underline">
              <span class="box-title-text">
                @if (!showSpinner) {
                  <mat-icon fontSet="material-icons-outlined">description</mat-icon>
                  @if (entity?.name) {
                    <span>Files for {{ entity.name }}</span>
                  }
                  @if (entity?.name) {
                    <span class="header-search-and-refresh">
                      <span class="header-search-input-wrapper">
                        <input #searchInputEl class="header-search-input" type="text" placeholder="Search (Ctrl+Shift+E)..."
                          (input)="onSearchInput($event)" (click)="$event.stopPropagation()" (keydown.escape)="clearSearch()" />
                        <mat-icon class="header-search-icon" [fontIcon]="searchInputEl.value ? 'close' : 'search'"
                          (click)="clearSearch(); $event.stopPropagation()"></mat-icon>
                      </span>
                      <mat-icon
                        class="sync-icon"
                        (click)="refreshFiles($event)"
                        [matTooltip]="'Resync files with ' + entity.name"
                        matTooltipShowDelay="500"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="refreshFiles($event)"
                      >autorenew</mat-icon
                        >
                    </span>
                  }
                }
              </span>
            </h3>
          }
            @if (entity && !showSpinner && files.length === 0) {
              <div class="box-no-files-text placeholder-text">
                NO FILES AVAILABLE FOR THIS ENTITY
              </div>
            }
            <app-kp-simple-table
              [items]="files"
              [columnHeadings]="columnHeadings"
              [isLoading]="showSpinner"
              [skeletonRowClasses]="'big-row'"
              [skeletonRowInstances]="3"
              [tableClasses]="'hover-rows'"
              [searchFn]="fileSearchFn"
              (actionClick)="itemActionClick($event)"
              (rowDoubleClick)="itemRowDoubleClick($event)"
              >
            </app-kp-simple-table>
          </div>
        </section>
      }
    </article>
  }
